import Vue from 'vue';

/**
 * @author Duke
 *
 */
import zhInput from './src/zhInput.vue';

zhInput.install = function (Vue) {
  Vue.component(zhInput.name, zhInput);
};

export default zhInput;



// WEBPACK FOOTER //
// ./ui/input/index.js